import { Injectable } from '@angular/core';
import { interval } from 'rxjs';
import { ABM_USER } from '../global/constants';
import { AbmHttpMethod, AbmRequestLink, AbmUser, AbmUserAction, AbmUserBehavior } from '../global/types';
import { AbmEncrypt } from '../utils/abm-encrypt';
import { AbmDataService } from './abm-data.service';

@Injectable({
    providedIn: 'root'
})
export class AbmAccountService {

    public user: AbmUser;
    public isLogin = false;
    public redirectUrl: string;
    public rememberme = false;

    private ubRequest = new AbmRequestLink('behavior.json', 'entities/abmbe_FeActivities', AbmHttpMethod.POST);

    constructor(
        private _dataService: AbmDataService,
    ) {
        this._renewToken(60);
        if (!this.user) {
            this.loadStoredUser();
        }
    }

    public loadStoredUser(): AbmUser {
        const userStr = window.localStorage.getItem(ABM_USER);

        if (userStr === null) {
            this.user = new AbmUser();
            return null;
        } else {
            const storedUser: AbmUser = JSON.parse(userStr);
            storedUser.password = AbmEncrypt.basicDecrypt(storedUser.password);
            storedUser.tokenExpireStr = storedUser.tokenExpireStr;
            this.rememberme = true;
            this.isLogin = storedUser.tokenExpire.getTime() > new Date().getTime();
            this.user = storedUser;
            return storedUser;
        }
    }

    public saveUser(rememberMe: boolean, user: AbmUser) {
        this.user = user;
        this.rememberme = rememberMe;

        if (rememberMe) {
            window.localStorage.setItem(ABM_USER, JSON.stringify(user));
        } else {
            window.localStorage.removeItem(ABM_USER);
        }
    }

    public login(user: AbmUser) {
        return this._dataService.login(user.name, user.password);
    }

    public logout() {
        return this._dataService.logout();
    }

    public recordBehavior(actionType: AbmUserAction, actionName: string) {
        const ub = new AbmUserBehavior(this.user.name, actionType, actionName, window.navigator.userAgent);

        this._dataService.getData(this.ubRequest, { body: ub }).subscribe();
    }

    private _renewToken(sec: number) {
        const second = interval(sec * 1000);

        second.subscribe(() => {
            if (new Date() > this.user.tokenExpire) {
                this.login(this.user).subscribe(user => {
                    this.saveUser(this.rememberme, this.user);
                });
            }
        });
    }
}
